var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgManufactured = function SvgManufactured(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.78 3.716 1.22.948-.845.656L6 1.313.845 5.32 0 4.664 6 0l3.187 2.477V1.24h1.594v2.477ZM6 2.192l4.78 3.71V9.6H1.22V5.902L6 2.192Zm1.594 6.789V5.884H4.406V8.98h3.188ZM3.598 12a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Zm.018-.822a.329.329 0 1 0 0-.657.329.329 0 0 0 0 .657Zm5.983-.378a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0Zm-.887.05a.329.329 0 1 1-.657 0 .329.329 0 0 1 .657 0Z",
    fill: "#fff"
  })));
};
export default SvgManufactured;